import { getTermsValue, resetTerms, setTerms } from '../../../../JsonQuery';
import { TTagsManager } from '../../types/tag';
import { createTagValue } from '../../utils/createTagValue';
import { EBuildingHeatingType } from '../../../../api-models/common/json_query';

const ID = 'buildingHeatingType' as const;

const HEATING_TYPE_MAP_VALUE_TO_LABEL: Record<EBuildingHeatingType, string> = {
  [EBuildingHeatingType.Autonomous]: 'Автономное отопление',
  [EBuildingHeatingType.Central]: 'Центральное отопление',
  [EBuildingHeatingType.Without]: 'Без отопления',
};

export const buildingHeatingTypeTagsManager: TTagsManager = {
  id: ID,
  extractTagsFromJsonQuery: ({ jsonQuery }) => {
    const types = getTermsValue('building_heating_type')(jsonQuery);

    if (types === null) {
      return null;
    }

    return types.map(t => ({
      label: HEATING_TYPE_MAP_VALUE_TO_LABEL[t],
      value: createTagValue(ID, t.toString()),
    }));
  },
  modifyJsonQueryByRemovingTag: ({ jsonQuery, removingTagValue }) => {
    const types = getTermsValue('building_heating_type')(jsonQuery);

    if (types === null) {
      return jsonQuery;
    }

    const next = types.filter(t => String(t) !== removingTagValue);

    return next.length > 0
      ? setTerms('building_heating_type')(jsonQuery)(next)
      : resetTerms(['building_heating_type'])(jsonQuery);
  },
};
